import moment from "moment";
import { commonLabels } from "../component/Patient/PatientApplications/PatientApplicationDetails/trackComponents/consts/trackFieldLabels";
import { preparationDetailsFieldNames } from "../component/Patient/PatientApplications/PatientApplicationDetails/trackComponents/consts/trackFieldNames";
import { INTERNAL_PROGRAM, prioritiesMap } from "../constant/assistanceProgram";
import { EMPTY_VALUE } from "../constant/trackTab";
import { APPLICATIONS } from "../constant/applications";
import { dateFormatter } from "./date";
import { isValidDate } from "./formaters";

export const inactiveStatuses = [
  APPLICATIONS.statuses.canceled,
  APPLICATIONS.statuses.rejected,
  APPLICATIONS.statuses.ineligible,
  APPLICATIONS.statuses.notInterested,
  APPLICATIONS.statuses.notReturned,
  APPLICATIONS.statuses.missingInformation
];

export const formatAPType = (t, { priority, internal }) => {
  if (internal) {
    return t(`patientPotentialSavings.${prioritiesMap[INTERNAL_PROGRAM].text}`);
  } else {
    return prioritiesMap[priority] ? t(`patientPotentialSavings.${prioritiesMap[priority].text}`) : "";
  }
};

export const getApplicationDisplayName = (application, hideAssociatedDrugs = false) => {
  const hasAssociatedDrugs = application.associatedDrugs.length > 0;
  const baseName = hasAssociatedDrugs ? application.potentialSaving.name : application.displayName;

  return hasAssociatedDrugs && !hideAssociatedDrugs
    ? `${baseName} (${application.associatedDrugs.join(", ")})`
    : baseName;
};

export const getFormattedTextForCopy = ({ t, application, fieldNames, tableKey, statusKey, Statuses }) => {
  const fieldLabels = commonLabels[tableKey];

  return Object.keys(fieldNames)
    .map((key) => {
      const shouldSkipPersonNameYouSpokeTo =
        key === preparationDetailsFieldNames.personNameYouSpokeTo && statusKey === Statuses.prepare.key;
      if (shouldSkipPersonNameYouSpokeTo) {
        return null;
      }

      const label = t(fieldLabels?.[key] ?? key);
      const value = application?.[fieldNames[key]] ? application[fieldNames[key]] : EMPTY_VALUE;
      const formattedValue = isValidDate(value) ? dateFormatter(value) : value;

      return formattedValue ? `${label}: ${formattedValue}` : null;
    })
    .filter(Boolean)
    .join("\n");
};

/**
 * Helper function to calculate inactive status dates based on current status
 * @param {Object} params
 * @param {string} params.currentStatus - The current application form status
 * @param {string|null} params.existingCanceledDate - Existing canceled date from database
 * @param {string|null} params.existingRejectedDate - Existing rejected date from database
 * @returns {Object} Object with canceledDate and rejectedDate as moment or null
 */
export const getInactiveStatusDates = ({ currentStatus, existingCanceledDate, existingRejectedDate }) => {
  const isInactiveStatus = inactiveStatuses.includes(currentStatus);
  const shouldSetCanceledDate = isInactiveStatus && currentStatus !== APPLICATIONS.statuses.rejected;
  const shouldSetRejectedDate = currentStatus === APPLICATIONS.statuses.rejected;

  return {
    canceledDate: existingCanceledDate ? moment(existingCanceledDate) : shouldSetCanceledDate ? moment() : null,
    rejectedDate: existingRejectedDate ? moment(existingRejectedDate) : shouldSetRejectedDate ? moment() : null
  };
};
